// @ts-strict-ignore
import React from 'react';
import $ from 'jquery';
import pluralize from 'pluralize';
import styled from 'styled-components';

import { truncate } from './formatting';

type Message = JQuery<Element> | null | undefined;
let messageInterval: ReturnType<typeof setTimeout> | null = null;
let currentMessage: Message = null;
let messageCount = 0;


function displayMessage(message: Message) {
  message?.animate({ opacity: '1' }, 500);
}


function removeMessage(message: Message) {
  message?.animate({ opacity: 0 },
    500,
    'linear',
    function remove(this: any) {
      $(this)?.remove();
    });
}


function nextMessage() {
  const next = currentMessage?.next('li.message');
  removeMessage(currentMessage);
  messageCount -= 1;
  $('ul#messages span.message-count').text(messageCount > 1 ? messageCount - 1 : '');

  // Stop the interval and delete the message when there are no more to display
  if (!next?.length) {
    if (messageInterval) {
      clearInterval(messageInterval);
    }
    messageInterval = null;
    removeMessage(next);
  }

  setTimeout(() => {
    currentMessage = next;
    displayMessage(currentMessage);
  }, 550);
}

export function flashMessages(
  messages: string | ((string | undefined)[]), duration?: number,
) {
  // Add the messages to the ul
  if (messages?.length > 0) {
    const messagesArray = Array.isArray(messages) ? messages : [messages];
    messagesArray.forEach(message => {
      const newMessage = `
        <li class="message">
          <span class="text">${message}</span>
        </li>
      `;
      $('ul#messages')
        .append(newMessage);
    });
  }

  // Update the count of the messages currently queued
  messageCount = $('ul#messages li.message').length ?? 0;
  $('ul#messages span.message-count')
    .text(messageCount > 1 ? messageCount - 1 : '');

  if (!messageInterval && !!$('ul#messages li.message')?.length) {
    currentMessage = $('ul#messages li.message')?.eq(0);
    displayMessage(currentMessage);
    // Display the messages one at a time
    messageInterval = setInterval(nextMessage, duration || 3500);
  }
}

export function genericErrorMessage(createMessage = null, addSnackBar = null) {
  const errorMessage = 'Something went wrong! Please try again or contact support.';
  if (addSnackBar) {
    addSnackBar({ title: errorMessage, type: 'danger' });
  } else {
    const message = createMessage ?? flashMessages;
    message([errorMessage]);
  }
}

// Simple event handler for clipboard copying to flash what was copied
export function handleClipboardCopyText(event: ClipboardJS.Event) {
  return `'${truncate(event?.text, 50)}' copied to clipboard.`;
}

// Simple event handler for clipboard copying to flash what was copied
export function handleClipboardCopy(event: ClipboardJS.Event, createMessage = null) {
  const message = createMessage ?? flashMessages;
  message([handleClipboardCopyText(event)]);
}

// Returns an element based on the given number of duplicate entities and evaluations
export function generateDuplicateEntitiesAndEvaluationsText(
  entityCount: number,
  evaluationCount: number,
): JSX.Element {
  const LinkText = styled.u`
    white-space: nowrap;
    margin-left: 4px;
  `;
  const entitiesText = pluralize('other entity', entityCount, true);
  const evaluationsText = pluralize('other evaluation', evaluationCount, true);
  let returnContent = null;
  if (entityCount && evaluationCount) {
    returnContent = (
      <>
        <b>{entitiesText}</b> and <b>{evaluationsText}</b>
      </>
    );
  } else if (entityCount) {
    returnContent = <b>{entitiesText}</b>;
  } else returnContent = <b>{evaluationsText}</b>;

  return (
    <>
      {returnContent}
      <LinkText>
        View All
      </LinkText>
    </>
  );
}
